<template lang="pug">
    include ../../media/pug/mixins
    +b.SECTION.available
        +e.H2.title.title._size_md._theme_secondary(v-if="isMobile") {{ $t('ACCESS') }}
        +e.UL.list._border_right
            +e.LI.item._title Разрешено
            +e.LI.item._is_grey
                +e.SPAN.inner-item
                    v-icon(name="eye2")
                +e.SPAN.inner-item(v-html="pages")
            +e.item._is_grey
                +e.SPAN.inner-item
                    v-icon(name="print")
                +e.SPAN.inner-item(v-html="pages")
        +e.UL.list
            +e.LI.item._title Доступно документов
            +e.LI.item._is_grey
                +e.SPAN.inner-item(v-html="available")
                +e.SPAN.inner-item._is_orange(v-html="dateFor")
        +e.UL.list._border_left
            +e.LI.item._title Сегодня
            +e.LI.item
                +e.SPAN.inner-item._is_blue.link.link_dashed(
                    v-on:click="openModal"
                    v-html="availableToday"
                )
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters([
            'isMobile'
        ]),
        pages() {
            return '<b> 100% </b> / 128 стр.';
        },
        available() {
            return '<b>100 из 100 до</b>';
        },
        dateFor() {
            return '<b>30.10.2019</b>';
        },
        availableToday() {
            return this.isMobile ? 'доступно <b>100</b> из 100' : '<b>доступно 100 из 100</b>';
        }
    },
    methods: {
        openModal() {
            this.$store.dispatch('showModal', 'ModalTestRoom');
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/modules/available-panel.sass"></style>
